import { Browser } from '@capacitor/browser';
import { AnalyticsEvent, trackAnalyticsEvent } from '../services/analytics';

export function openInNewWindow({ url }: { url: string }) {
  Browser.open({ url });
  trackAnalyticsEvent(AnalyticsEvent.url_opened, { url });
}
